import { focusManager } from '@tanstack/vue-query';

/**
 * Configures TanStack Query's focusManager to detect both:
 * - Tab visibility changes (default behavior)
 * - Window focus/blur events (OS-level focus changes)
 *
 * By default, TanStack Query only listens to `visibilitychange` which fires
 * on tab switches. This setup adds `focus`/`blur` listeners so refetching
 * also triggers when the browser window itself gains focus from another app.
 */
export function setupQueryFocusManager(): void {
  focusManager.setEventListener((handleFocus) => {
    const visibilityHandler = () => handleFocus(!document.hidden);
    const focusHandler = () => handleFocus(true);
    const blurHandler = () => handleFocus(false);

    // Default: visibilitychange (tab switch)
    document.addEventListener('visibilitychange', visibilityHandler);

    // Additional: window focus/blur (OS-level)
    window.addEventListener('focus', focusHandler);
    window.addEventListener('blur', blurHandler);

    return () => {
      document.removeEventListener('visibilitychange', visibilityHandler);
      window.removeEventListener('focus', focusHandler);
      window.removeEventListener('blur', blurHandler);
    };
  });
}
